import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type PassInfoState = {
  passInfo?: unknown | null;
  auth?: unknown | null;
};

const initialState: PassInfoState = {
  passInfo: null,
  auth: null,
};

const passInfoSlice = createSlice({
  name: 'passInfo',
  initialState,
  reducers: {
    HYDRATE: (state, action: PayloadAction<PassInfoState>) => {
      return { ...state, ...action.payload };
    },
    passInfoSet: (state, action: PayloadAction<unknown>) => {
      state.passInfo = action.payload;
    },
    passInfoInit: (state) => {
      state.passInfo = null;
    },
    passAuthSet: (state, action: PayloadAction<unknown>) => {
      state.auth = action.payload;
    },
    passAuthInit: (state) => {
      state.auth = null;
    },
  },
});

export const passInfoActions = passInfoSlice.actions;

export default passInfoSlice;
